import { useLocationStore } from "./locationStore";
import { LOCATION_REQUIRED } from "./locationPolicy";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  Divider,
} from "@mui/material";

export default function LocationPermissionDialog() {
  const open = useLocationStore((s) => s.promptOpen);
  const reason = useLocationStore((s) => s.promptReason);
  const respond = useLocationStore((s) => s.respondToPrompt);

  if (!open) return null;

  const reasonLabel = LOCATION_REQUIRED
    ? "use this app"
    : reason === "note"
      ? "attach your notes to the right place"
      : "improve nearby search results";

  return (
    <Dialog
      open={open}
      onClose={() => {
        void respond("deny");
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{LOCATION_REQUIRED ? "Location required" : "Enable location?"}</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography variant="body1">
            {LOCATION_REQUIRED
              ? `Your company requires location access to ${reasonLabel}. We never track in the background.`
              : `We use your location to ${reasonLabel}. We never track in the background.`}
          </Typography>
          <Divider />
          <Stack spacing={0.5}>
            <Typography variant="body2">What to expect:</Typography>
            <Typography variant="body2" color="text.secondary">
              - One-time browser prompt after you confirm.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              - Used only when you search or add a note.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {LOCATION_REQUIRED
                ? "- If the browser blocks access, you will need to re-enable it in browser or device settings."
                : "- You can change this later in Settings."}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            void respond("deny");
          }}
        >
          {LOCATION_REQUIRED ? "Cancel" : "Not now"}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            void respond("allow");
          }}
        >
          {LOCATION_REQUIRED ? "Enable location" : "Allow location"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
